import React from "react"
import { ModalSeeker } from "@ui-seeker/core"
import { isOpenProvidersSuppliersMappingModal } from "Pages/Admin/ProvidersSuppliersMapping/@signals"
import { Box, Chip, Divider, Grid, Typography } from "@mui/material"
import NormalizeField from "Pages/Admin/ProvidersSuppliersMapping/Modal/NormalizeField"


export default function ProvidersSuppliersMappingModal() {

	if (!isOpenProvidersSuppliersMappingModal.value?.length) return null


	return <ModalSeeker
		title="Edit Mappings"
		isOpen={!!isOpenProvidersSuppliersMappingModal.value?.length}
		controller={() => isOpenProvidersSuppliersMappingModal.value = []}
		hideActions
	>
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<Typography variant="h5">Selected raw data:</Typography>
				<Box sx={{ display: "flex", alignItems: "center", justifyContent: "start", gap: 1, my: 1 }}>
					{isOpenProvidersSuppliersMappingModal.value?.map(({ rawData }, idx) => {
						return <Chip
							sx={{ p: .5 }}
							label={rawData}
							key={`${rawData}-${idx}`}/>
					})}
				</Box>
				<Divider sx={{ my: 2, color: 'secondary.main' }}/>
				<Box>
					<NormalizeField/>
				</Box>
			</Grid>
		</Grid>
	</ModalSeeker>
}